import '../../stylesheets/src/sass/forms-editor.scss'

export default angular
    .module('syForm', [])
    /**
     * @ngdoc service
     * @name syForm.service:syFormTooltipService
     * @description
     * Creates a service that handles tooltip service.
     */
    // @ngInject

    .controller('BulkUploadController', [
        function BulkUploadController() {
            var self = this
            this.itemType = ''
            this.portalID = ''
            this.portalName = ''
            this.email = ''
            this.showPortal = false
            this.CheckItemTypeT2C = function () {
                self.showPortal = self.itemType == '32544461-d129-495f-8456-8c0baf90314b' ? true : false
            }
        }
    ])
    .service('syFormTooltipService', [
        function syFormTooltipService() {
            var self = this

            this.active = null
            this.toggleTooltip = function (element) {
                if (element && self.active && self.active === element) {
                    self.active.toggleClass('field-group-tooltip--active')
                    if (!self.active.hasClass('field-group-tooltip--active')) {
                        self.active = null
                    }
                } else {
                    self.setTooltip(element)
                }
            }
            this.setTooltip = function (element) {
                if (element) {
                    if (self.active && self.active !== element) {
                        self.setTooltip(null)
                    }
                    if (!self.active) {
                        self.active = element
                        self.active.addClass('field-group-tooltip--active')
                    }
                } else if (self.active && self.active.hasClass('field-group-tooltip--active')) {
                    self.active.removeClass('field-group-tooltip--active')
                    self.active = null
                }
            }
        }
    ])
    /**
     * @ngdoc service
     * @name syForm.service:syFormEditService
     * @description
     * Creates a service that handles form review edit service.
     */
    // @ngInject
    .service('syFormEditService', [
        function syFormEditService() {
            var self = this

            this.EDIT = 1
            this.SAVE = 2
            this.CANCEL = 3
            this.IDLE = 4

            this.inputs = []
            this.getInput = function (input) {
                for (var i = 0; i < self.inputs.length; i++) {
                    if (self.inputs[i].element === input) {
                        return self.inputs[i]
                    }
                }
                return null
            }
            this.getInputState = function (input) {
                var value = self.getInput(input)
                return value ? value.state : self.IDLE
            }
            this.getInputValue = function (input) {
                var value = self.getInput(input)
                return value ? value.value : null
            }
            this.setFieldState = function (element, isEdit) {
                if (isEdit) {
                    if (!element.hasClass('submission-datalist-group--active')) {
                        element.addClass('submission-datalist-group--active')
                    }
                } else {
                    if (element.hasClass('submission-datalist-group--active')) {
                        element.removeClass('submission-datalist-group--active')
                    }
                }
            }
            this.editField = function (element, inputs) {
                // Set the field in edit mode
                self.setFieldState(element, true)

                // Set the inputs as in EDIT mode
                for (var i = 0; i < inputs.length; i++) {
                    var value = self.getInput(inputs[i])
                    var isRadio = inputs[i].tagName === 'INPUT' && inputs[i].type === 'radio'
                    if (value) {
                        value.state = self.EDIT
                        value.value = isRadio ? inputs[i].checked : angular.element(inputs[i]).val()
                    } else {
                        self.inputs.push({
                            element: inputs[i],
                            state: self.EDIT,
                            value: isRadio ? inputs[i].checked : angular.element(inputs[i]).val()
                        })
                    }
                }
            }
            this.saveField = function (element, inputs) {
                // Set the field in readonly mode
                self.setFieldState(element, false)

                // Set the inputs as in SAVE mode
                for (var i = 0; i < inputs.length; i++) {
                    var value = self.getInput(inputs[i])
                    if (value) {
                        value.state = self.SAVE
                    }
                }
            }
            this.cancelField = function (element, inputs) {
                // Set the field in readonly mode
                self.setFieldState(element, false)

                // Set the inputs as in CANCEL mode
                for (var i = 0; i < inputs.length; i++) {
                    var value = self.getInput(inputs[i])
                    if (value) {
                        value.state = self.CANCEL
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc service
     * @name syForm.service:syFormHistoryService
     * @description
     * Creates a service that handles form history service.
     */
    // @ngInject
    .service('syFormHistoryService', [
        '$window',
        'AdobeFormModel',
        'AdobeProductModel',
        'AdobeAnalyticsService',
        function syFormHistoryService($window, AdobeFormModel, AdobeProductModel, AdobeAnalyticsService) {
            var self = this
            this._history = []

            // Set up the form and it's watch and hash functions.
            this.setupForm = function (scope, watchFunction, hashFunction) {
                self._history = []

                scope.$watch(watchFunction, function (newValue) {
                    $window.location.href =
                        $window.location.protocol +
                        '//' +
                        $window.location.host +
                        $window.location.pathname +
                        '##step' +
                        newValue
                })

                scope.$watch(function () {
                    return $window.location.hash
                }, hashFunction)
            }

            this.referenceId = ''
            this.trackAdobeAnalytics = function (step) {
                self.setAdobeAnalyticsProductModel()
                var stage = step == 1 ? 'start' : step == 4 ? 'complete' : 'incomplete'
                var stepName =
                    step == 1 ? 'offer' : step == 2 ? 'details' : step == 3 ? 'review' : step == 4 ? 'complete' : ''
                var formName = location.pathname.split('/')[2]
                var referenceId = step == 4 ? self.referenceId : ''
                AdobeFormModel.name = formName ? formName.toLowerCase() : location.pathname
                AdobeFormModel.stage = stage
                AdobeFormModel.step = step
                AdobeFormModel.stepName = stepName
                AdobeFormModel.type = 'engagement'
                AdobeFormModel.referenceId = referenceId
                AdobeAnalyticsService.trackFormNavigation(AdobeFormModel)
            }
            this.setAdobeAnalyticsProductModel = function () {
                var signUpData = localStorage.getItem('SignUpData')
                if (signUpData != null) {
                    var signUpDataJson = JSON.parse(signUpData)
                    AdobeProductModel.name = signUpDataJson.offer.productName
                }
            }

            // Add an entry into the history.
            this.addToHistory = function (token) {
                if (!self.hasToken(token)) {
                    self._history.push(token)
                    self.trackAdobeAnalytics(token)
                }
            }

            // Check if the token exists in the history.
            this.hasToken = function (token) {
                for (var i = 0; i < self._history.length; i++) {
                    if (self._history[i] === token) {
                        return true
                    }
                }
                return false
            }

            // Clears the history.
            this.clear = function () {
                this._history = []
            }
        }
    ])
    /**
     * @ngdoc service
     * @name syForm.service:syFormAddressService
     * @description
     * Creates a service that handles form address search service.
     */
    // @ngInject
    .service('syFormAddressService', [
        '$timeout',
        '$http',
        '$compile',
        '$rootScope',
        function ($timeout, $http, $compile, $rootScope) {
            var templateComponent =
                "<div class='predictive-results predictive-results--active' ng-controller='addressController'>" +
                "<ul class='result-list'>" +
                "<li ng-repeat='result in results()' class='result-list-item'>" +
                "<p ng-if=\"result.code === 'NO_MATCHES'\">{{result.label}}</p><a ng-if=\"result.code !== 'NO_MATCHES'\" href='#' ng-click='select($event, result.label)'>{{result.label}}</a>" +
                '</li>' +
                '</ul>' +
                '</div>'
            var self = this
            this._slots = []

            var createNewSlot = function (id, attrs) {
                if (self._slots[id]) {
                    self._slots[id] = undefined
                }
                self._slots[id] = {
                    isFocus: false,
                    results: [],
                    count: 0,
                    selected: undefined,
                    config: {
                        queryProperty: 'search',
                        action: '',
                        method: 'GET'
                    }
                }

                // Set up any search configs
                if (attrs) {
                    if (attrs.queryProperty) {
                        self._slots[id].config.queryProperty = attrs.queryProperty
                    }
                    if (attrs.action) {
                        self._slots[id].config.action = attrs.action
                    }
                    if (attrs.method) {
                        self._slots[id].config.method = attrs.method
                    }
                }
            }

            // Add the address components
            this.addAddressComponents = function (parent, id, attrs) {
                // Create new slot for id.
                createNewSlot(id, attrs)

                // Add the search components to the parent
                var component = angular.element(templateComponent)
                parent.append($compile(component)($rootScope))

                // Add any scope values
                var scope = component.scope()
                if (scope) {
                    scope.id = id
                }
            }

            // Get the results
            this.getResults = function (id) {
                var slot = self._slots[id]
                return slot ? slot.results : []
            }

            // Set the focus
            this.setFocus = function (id, value) {
                var slot = self._slots[id]
                if (slot) {
                    slot.isFocus = value
                }
            }

            // Display the results
            this.toggleResults = function (parent, id) {
                var slot = self._slots[id]
                var visible = slot && slot.isFocus && slot.results.length > 0
                $timeout(
                    function () {
                        parent.toggleClass('predictive-search--active', visible)
                    },
                    visible ? 0 : 250
                )
            }

            // Returns the selected value (and clear it)
            this.selectedValue = function (id) {
                var slot = self._slots[id]
                if (!slot) {
                    return undefined
                }

                var value = slot.selected
                slot.selected = undefined
                return value
            }

            // Set the selected value
            this.setSelectedValue = function (id, value) {
                var slot = self._slots[id]
                if (!slot) {
                    return
                }

                slot.selected = value
            }

            // Initiate a search
            this.search = function (parent, id, value) {
                var slot = self._slots[id]
                if (!slot) {
                    return
                }

                slot.results = []
                if (value && value.length > 2) {
                    // Use a count to prevent multiple requests
                    var count = ++slot.count
                    var params = { section: '' }
                    params[slot.config.queryProperty] = value
                    $http({
                        url: slot.config.action,
                        method: slot.config.method,
                        params: params
                    })
                        .success(function (data) {
                            if (slot.count !== count) {
                                return;
                            } else {
                                slot.results = data.results || data
                                self.toggleResults(parent, id)
                            }
                        })
                        .error(function () {})
                }
            }
        }
    ])
    /**
     * @ngdoc service
     * @name syModal.controller:addressController
     * @description
     * Creates a controller to handle address search functions.
     */
    // @ngInject
    .controller('addressController', [
        '$scope',
        'syFormAddressService',
        function ($scope, syFormAddressService) {
            // Define the default values
            $scope.id = undefined
            $scope._results = []

            // Get and display the results.
            $scope.results = function () {
                $scope._results = []
                if ($scope.id) {
                    $scope._results = syFormAddressService.getResults($scope.id)
                }
                return $scope._results
            }

            // Select the address
            $scope.select = function (event, label) {
                event.preventDefault()
                syFormAddressService.setSelectedValue($scope.id, label)
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syForm.directive:syFormTooltip
     * @description
     * Sets up tooltip function to the field.
     */
    // @ngInject
    .directive('syFormTooltip', [
        'syFormTooltipService',
        function (syFormTooltipService) {
            return {
                restrict: 'A',
                link: function ($scope, $element) {
                    // Retrieve the button
                    var buttons = $element.find('button.form-tooltip-toggle')

                    // Append the tooltip function on the buttons
                    angular.element(buttons).on('click touchend', function (evt) {
                        evt.preventDefault()
                        $scope.$apply(function () {
                            syFormTooltipService.toggleTooltip($element)
                        })
                    })

                    // Retrieve the form inputs
                    var inputs = $element.find('input.form-input')
                    var textAreas = $element.find('textarea.form-input')
                    var selects = $element.find('select.form-input')
                    var formButtons = $element.find('button.form-input')

                    // Append the tooltip function on the inputs
                    var inputFunction = function (evt) {
                        evt.preventDefault()
                        if (angular.element(this).attr('readonly')) {
                            return
                        }

                        $scope.$apply(function () {
                            syFormTooltipService.setTooltip($element)
                        })
                    }
                    angular.element(inputs).on('focus', inputFunction)
                    angular.element(textAreas).on('focus', inputFunction)
                    angular.element(selects).on('focus', inputFunction)
                    angular.element(formButtons).on('click touchend', inputFunction)
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syForm.directive:syFormTooltip
     * @description
     * Sets up tooltip function to the field.
     */
    // @ngInject
    .directive('syAnalyticsError', [
        function () {
            return {
                restrict: 'A',

                link: function ($scope) {
                    $scope.$watch(
                        function () {
                            return $scope.confirmDetailsForm.$error.required
                                ? $scope.confirmDetailsForm.$error.required.length
                                : -1
                        },
                        function () {
                            let formError = null
                            $.each($scope.confirmDetailsForm.$error, function (item, index) {
                                if (item == 'required') {
                                    for (var i = 0; i < index.length; i++) {
                                        formError = {}
                                        // Step 3: populate the form error and push it into the form error array
                                        formError.message =
                                            $('[name=' + index[i].$name + ']')
                                                .parent('div')
                                                .parent('div')
                                                .find('.form-error')[0] != undefined
                                                ? $('[name=' + index[i].$name + ']')
                                                      .parent('div')
                                                      .parent('div')
                                                      .find('.form-error')[0].innerText
                                                : $('[name=' + index[i].$name + ']')
                                                      .parent('div')
                                                      .parent('div')
                                                      .next('div')
                                                      .closest('div')
                                                      .find('.form-error')[0].innerText
                                        formError.location = index[i].$name
                                    }
                                }
                            })
                        }
                    )
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syForm.directive:syFormEditable
     * @description
     * Sets up inline edit function to the field.
     */
    // @ngInject
    .directive('syFormEditable', [
        'syFormEditService',
        function (syFormEditService) {
            return {
                restrict: 'A',
                link: function ($scope, $element) {
                    // Add class to current element
                    if (!$element.hasClass('submission-datalist-group--editable')) {
                        $element.addClass('submission-datalist-group--editable')
                    }

                    // Retrieve the buttons
                    var editButton = $element.find('.btn.btn--edit')
                    var saveButton = $element.find('.btn.btn--save')
                    var cancelButton = $element.find('.btn.btn--cancel')

                    // Attach the button functions
                    angular.element(editButton).on('click touchend', function (evt) {
                        evt.preventDefault()
                        $scope.$apply(function () {
                            var inputs = $element.find('input.form-input')
                            inputs = inputs.add($element.find('select.form-input'))
                            syFormEditService.editField($element, inputs)
                        })
                    })
                    angular.element(saveButton).on('click touchend', function (evt) {
                        evt.preventDefault()
                        $scope.$apply(function () {
                            var inputs = $element.find('input.form-input')
                            inputs = inputs.add($element.find('select.form-input'))
                            syFormEditService.saveField($element, inputs)
                        })
                    })
                    angular.element(cancelButton).on('click touchend', function (evt) {
                        evt.preventDefault()
                        $scope.$apply(function () {
                            var inputs = $element.find('input.form-input')
                            inputs = inputs.add($element.find('select.form-input'))
                            syFormEditService.cancelField($element, inputs)
                        })
                    })
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syForm.directive:syFormEditableInput
     * @description
     * Sets up inline edit function to the input.
     */
    // @ngInject
    .directive('syFormEditableInput', [
        'syFormEditService',
        function (syFormEditService) {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: true,
                link: function ($scope, $element, attrs, ngModel) {
                    // Only applies to inputs and selects
                    if ($element[0].tagName !== 'INPUT' && $element[0].tagName !== 'SELECT') {
                        return
                    }

                    var getInputState = function () {
                        return syFormEditService.getInputState($element[0])
                    }

                    var isRadioButton = function () {
                        return $element[0].tagName === 'INPUT' && $element[0].type === 'radio'
                    }

                    var isSelect = function () {
                        return $element[0].tagName === 'SELECT'
                    }

                    // Set up watch on the input state
                    $scope.$watch(getInputState, function (state) {
                        switch (state) {
                            case syFormEditService.CANCEL:
                                var oldValue = syFormEditService.getInputValue($element[0])
                                if (isRadioButton()) {
                                    if (oldValue) {
                                        ngModel.$setViewValue($element.val(), 'cancel')
                                    }
                                } else {
                                    ngModel.$setViewValue(oldValue, 'cancel')
                                }
                                ngModel.$render()
                            case syFormEditService.SAVE:
                                if (ngModel.$invalid && !ngModel.$dirty) {
                                    ngModel.$setDirty(true)
                                }
                            case syFormEditService.IDLE:
                                // Set input into readonly mode
                                if (!$element.attr('readonly')) {
                                    $element.attr('readonly', 'readonly')
                                }
                                if ((isRadioButton() || isSelect()) && !$element.attr('disabled')) {
                                    $element.attr('disabled', 'disabled')
                                }
                                break
                            case syFormEditService.EDIT:
                                // Set input into edit mode
                                if ($element.attr('readonly')) {
                                    $element.removeAttr('readonly')
                                }
                                if ((isRadioButton() || isSelect()) && $element.attr('disabled')) {
                                    $element.removeAttr('disabled')
                                }
                                break
                        }
                    })
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syForm.directive:syFormStartDirty
     * @description
     * Sets up inline edit function to the input.
     */
    // @ngInject
    .directive('syFormStartDirty', [
        function syFormStartDirty() {
            return {
                restrict: 'A',
                scope: false,
                link: function ($scope, $element, attrs) {
                    if (attrs.syFormStartDirty) {
                        var form = $scope[attrs.syFormStartDirty]
                        if (form) {
                            angular.forEach(form, function (val, key) {
                                if (!key.match(/\$/)) {
                                    val.$dirty = true
                                }
                            })
                        }
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syForm.directive:syFormAddressInput
     * @description
     * Sets up address search input.
     */
    // @ngInject
    .directive('syFormAddressInput', [
        'syFormAddressService',
        function syFormAddressInput(syFormAddressService) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function ($scope, $element, attrs, ngModel) {
                    var parent = $element.parent()
                    var id = attrs.id

                    if (parent && id) {
                        // Set up config
                        var config = {}
                        if (attrs.searchQuery) {
                            config.queryProperty = attrs.searchQuery
                        }
                        if (attrs.searchAction) {
                            config.action = attrs.searchAction
                        }
                        if (attrs.searchMethod) {
                            config.method = attrs.searchMethod
                        }

                        // Add address search components
                        syFormAddressService.addAddressComponents(parent, id, config)

                        // Set up event handlers
                        $element.focus(function () {
                            syFormAddressService.setFocus(id, true)
                            syFormAddressService.toggleResults(parent, id)
                        })

                        $element.blur(function () {
                            syFormAddressService.setFocus(id, false)
                            syFormAddressService.toggleResults(parent, id)
                        })

                        // Set up the formater
                        ngModel.$parsers.unshift(function (value) {
                            syFormAddressService.search(parent, id, value)
                            return value
                        })

                        // Set up the watches
                        $scope.$watch(
                            function () {
                                return syFormAddressService.selectedValue(id)
                            },
                            function (value) {
                                if (value) {
                                    ngModel.$setViewValue(value)
                                    ngModel.$render()
                                }
                            }
                        )
                    }
                }
            }
        }
    ])
